const Docs = () => {
    window.location.href = 'https://docs.mew-o.com/introduction/mew-o-backstory';
    return <></>;
};

export default Docs;
